import DefaultAvatar from 'components/Avatar';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { from } from 'styles/mixins';

// ============================================
// DROPDOWN PANEL
// ============================================

export const DropdownPanel = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding-top: 0.75rem;
  padding-bottom: 0;

  ${from.tabletH`
    border-radius: 4px;
    border: 0.8px solid ${({ theme }) => theme.colors.greyBlue};
    width: 25rem;
  `};
`;

export const PanelTitle = styled.h3`
  color: ${({ theme }) => theme.colors.grey400};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.3;
  letter-spacing: 0px;
  margin: 0;
  padding-inline: 0.75rem;
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: ${({ theme }) => theme.spacing.lg};
`;

// ============================================
// EMPTY STATE
// ============================================

export const NotificationsBellImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-block: ${({ theme }) => theme.spacing.lg};
`;

export const NotificationBellImage = styled.img`
  width: 109px;
  height: 69.563px;
`;

export const EmptyStateTitle = styled.h4`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  margin: 0 0 ${({ theme }) => theme.spacing.sm} 0;
  text-align: center;
  padding-inline: 0.75rem;
`;

export const EmptyStateDescription = styled.p`
  color: ${({ theme }) => theme.colors.grey400};
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.weights.regular};
  line-height: 1.4;
  margin: 0 0 ${({ theme }) => theme.spacing.sm} 0;
  text-align: center;
  padding-inline: 0.75rem;
`;

// ============================================
// ACTIVITY LIST
// ============================================

export const ActivityListContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-bottom: 0.75rem;
  padding-inline: 0.75rem;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0.375rem;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.grey200};
    border-radius: 0.1875rem;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.grey400};
    border-radius: 0.1875rem;
  }

  ${from.tabletH`
    max-height: 35rem;
    padding-bottom: 0;
  `};
`;

export const ActivityItem = styled.li`
  align-items: flex-start;
  display: flex;
  padding: 0.75rem 0;

  :not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey200};
  }
`;

export const ActivityAvatar = styled(DefaultAvatar)`
  margin-bottom: auto;
  margin-right: 0.625rem;
  height: 2.25rem;
  width: 2.25rem;
`;

export const ActivityText = styled.p`
  color: ${({ theme }) => theme.colors.grey400};
  font-weight: ${({ theme }) => theme.weights.regular};
  font-size: 0.875rem;
  line-height: 1.3;
  letter-spacing: 0px;
  margin: 0;
`;

export const ActivityLink = styled(Link)`
  color: ${({ theme }) => theme.colors.accent};
  font-weight: ${({ theme }) => theme.weights.semiBold};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const ActivityAction = styled.span``;

// ============================================
// FOOTER
// ============================================

export const DropdownFooter = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.grey200};
  margin-top: ${({ theme }) => theme.spacing.sm};
  padding-top: ${({ theme }) => theme.spacing.md};
`;

export const SeeAllLinkContainer = styled.div`
  padding-bottom: 1.5rem;
  padding-inline: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SeeAllLink = styled(Link)`
  color: ${({ theme }) => theme.colors.accent};
  display: block;
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  text-align: center;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryHover};
    text-decoration: underline;
  }
`;
